import React, { useEffect, useRef, useState } from "react";
import "../../styles/AboutSection/ScrollIndicator.scss";

interface Card {
  id: string;
  title: string;
  subtitle: string;
}

interface ScrollIndicatorProps {
  cards: Card[];
}

const AboutUsItems: React.FC<ScrollIndicatorProps> = ({ cards }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [offset, setOffset] = useState<number>(0);
  const cardRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    // Auto-scroll interval
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % cards.length);
    }, 3000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, [cards.length]);

  useEffect(() => {
    if (cardRef.current) {
      const activeCard = cardRef.current.children[activeIndex] as HTMLLIElement;

      if (activeCard) {
        const container = cardRef.current;
        const cardRect = activeCard.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        // Adjust offset to ensure the indicator aligns with text
        const newOffset =
          cardRect.top -
          containerRect.top +
          cardRect.height / 2 +
          container.scrollTop;

        setOffset(newOffset);
      }
    }
  }, [activeIndex]);

  if (!cards || cards.length === 0) {
    return <div>No cards available</div>;
  }

  return (
    <div className="about-content">
      <div className="slider">
        <div className="circle"></div>
        <div className="line"></div>
        <div
          className="indicator"
          style={{
            transform: `translateY(${offset}px)`,
          }}
        ></div>
        <div className="circle"></div>
      </div>

      <div className="tiles">
        <ul ref={cardRef}>
          {cards.map((card, index) => (
            <li key={card.id} className={activeIndex === index ? "active" : ""}>
              <strong>{card.title}</strong>
              <p className="subtitle">{card.subtitle}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AboutUsItems;
